import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { PrivateRoute, PublicRoute, AdminRoute } from "components/Routes";
import { ReactNotifications } from 'react-notifications-component'
import Login from "./pages/Login"
import Logout from "./pages/Logout"
import Register from "./pages/Register/Register"
import NavMenu from "./components/NavMenu"
import UserNavMenu from "./components/UserNavMenu"
import Footer from "./components/Footer"
import ValidateAccount from "./pages/ValidateAccount"
import AccountValidated from "./pages/AccountValidated"
import Packages from "./pages/Packages"
import AddEditPackage from "./pages/AddEditPackage"
import CargoMovement from "./pages/CargoMovement"
import AddEditCargoMovement from "./pages/AddEditCargoMovement"
import UserDashboard from "./pages/UserDashboard"
import UserProfile from "./pages/UserProfile";
import AddEditPackageCost from "pages/AddEditPackageCost/index.js";
import Prices from "pages/Prices/index.js";
import AddEditPrice from "pages/AddEditPrice/index.js";
import DashboardRoute from "components/Routes/DashboardRoute.jsx";
import DeliveryRoute from "pages/DeliveryRoute/index.js";
import AddEditDeliveryRoute from "pages/AddEditDeliveryRoute/index.js";
import PasswordReset from "pages/PasswordReset/index.js";
import AdminDashboard from "pages/AdminDashboard/index.js";
import { useEffect } from "react";
import ReactGA from 'react-ga4';
import Page from "components/Page/index.js";
import PoBoxMovement from "pages/PoBoxes";
import PackagesByPoBox from "pages/PackagesByPoBox";

const PageTracker = () => {
    const location = useLocation();

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }, [location]);

    return null
};

const AppRouter = () => {
    return (
        <Router>
            <PageTracker />
            <ReactNotifications />
            <NavMenu />
            <UserNavMenu />
            <div className="main-container">
                <Routes>
                    <Route path="/" element={
                        <Page title="Unboxing | Homepage">
                            <Login />
                        </Page>
                    } />
                    <Route path="/dashboard" element={
                        <Page title="Unboxing | Dashboard">
                            <DashboardRoute />
                        </Page>} />
                    <Route path="/admin" element={<AdminRoute />} >
                        <Route path="home" element={
                            <Page title="Unboxing | Admin">
                                <AdminDashboard />
                            </Page>} />
                        <Route path="poboxes" element={
                            <Page title="Unboxing | Admin Lista Casilleros">
                                <PoBoxMovement />
                            </Page>} />
                        <Route path="packagesByPoBox/:poBoxId" element={
                            <Page title="Unboxing | Lista de Paquetes de Casillero">
                                <PackagesByPoBox />
                            </Page>} />
                        <Route path="packages" element={
                            <Page title="Unboxing | Admin">
                                <Packages />
                            </Page>} />
                        <Route path="package" >
                            <Route path="add" element={
                                <Page title="Unboxing | Admin">
                                    <AddEditPackage />
                                </Page>} />
                            <Route path="edit/:id" element={
                                <Page title="Unboxing | Admin">
                                    <AddEditPackage />
                                </Page>} />
                            <Route path="cost/:id" element={
                                <Page title="Unboxing | Admin">
                                    <AddEditPackageCost />
                                </Page>} />
                        </Route>
                        <Route path="cargo-movements" element={
                            <Page title="Unboxing | Admin">
                                <CargoMovement />
                            </Page>} />
                        <Route path="cargo-movement" >
                            <Route path="add" element={
                                <Page title="Unboxing | Admin">
                                    <AddEditCargoMovement />
                                </Page>} />
                            <Route path="edit/:id" element={
                                <Page title="Unboxing | Admin">
                                    <AddEditCargoMovement />
                                </Page>} />
                        </Route>
                        <Route path="routes" element={
                            <Page title="Unboxing | Admin">
                                <DeliveryRoute />
                            </Page>} />
                        <Route path="route" >
                            <Route path="add" element={
                                <Page title="Unboxing | Admin">
                                    <AddEditDeliveryRoute />
                                </Page>} />
                            <Route path="edit/:id" element={
                                <Page title="Unboxing | Admin">
                                    <AddEditDeliveryRoute />
                                </Page>} />
                        </Route>
                        <Route path="prices" element={
                            <Page title="Unboxing | Admin">
                                <Prices />
                            </Page>} />
                        <Route path="price">
                            <Route path="add" element={
                                <Page title="Unboxing | Admin">
                                    <AddEditPrice />
                                </Page>} />
                            <Route path="edit/:id" element={
                                <Page title="Unboxing | Admin">
                                    <AddEditPrice />
                                </Page>} />
                        </Route>
                    </Route>
                    <Route path="/auth" element={<PublicRoute />} >
                        <Route path="login" element={
                            <Page title="Unboxing | Inicio de sesion">
                                <Login />
                            </Page>} />
                        <Route path="logout" element={
                            <Page title="Unboxing | Cerrar de sesion">
                                <Logout />
                            </Page>} />
                        <Route path="password-forgot" element={
                            <Page title="Unboxing | Reinicio Contraseña">
                                <PasswordReset />
                            </Page>} />
                        <Route path="register" element={
                            <Page title="Unboxing | Registro de usuario">
                                <Register />
                            </Page>} />
                        <Route path="validate-account" element={
                            <Page title="Unboxing | Validacion de Cuenta">
                                <ValidateAccount />
                            </Page>} />
                        <Route path="account-validated" element={
                            <Page title="Unboxing | Cuenta Validada">
                                <AccountValidated />
                            </Page>} />
                    </Route>
                    <Route path="/user" element={<PrivateRoute />} >
                        <Route path="dashboard" element={
                            <Page title="Unboxing | Dashboard Usuario">
                                <UserDashboard />
                            </Page>} />
                        <Route path="profile" element={
                            <Page title="Unboxing | Perfil de usuario">
                                <UserProfile />
                            </Page>} />
                    </Route>
                </Routes>
            </div>
            {/* <Footer /> */}
        </Router>
    );
};
export default AppRouter;